import { render, staticRenderFns } from "./QuestionnaireDetailModal.vue?vue&type=template&id=3f8a2354&scoped=true&"
import script from "./QuestionnaireDetailModal.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireDetailModal.vue?vue&type=style&index=0&id=3f8a2354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a2354",
  null
  
)

export default component.exports